import React from 'react';
import { toast as hotToast, } from 'react-hot-toast';
import { runIfFn } from '../utils/index.js';
import { ToastComponent } from './ToastComponent.js';
export const toast = (options) => {
    const { title, description, icon, status, custom, duration } = options;
    if (custom) {
        return hotToast.custom(t => (React.createElement(ToastComponent, { open: true, onClose: () => hotToast.remove(t.id), status: status }, runIfFn(custom, {
            onClose: () => hotToast.remove(t.id),
        }))), {
            duration,
        });
    }
    return hotToast.custom(t => (React.createElement(ToastComponent, { open: true, onClose: () => hotToast.remove(t.id), status: status },
        React.createElement(ToastComponent.Content, { title: title, description: description, icon: icon }))), {
        duration,
    });
};
//# sourceMappingURL=toast.js.map